<!--
 * @Description: 首页 常规工作/日常事务 学籍异动
 * @Author: PF
 * @Date: 2023-01-05 09:27:56
 * @LastEditors: PF
 * @LastEditTime: 2024-07-12 08:49:30
-->

<template>
  <div>
    <el-dialog class="w1200 h830" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">学籍异动</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select v-model="dataGrid.parms.zt" placeholder="异动类型" clearable @change='bindTable()' class="filter-item" filterable>
                  <el-option v-for="(item, index) in xjydlxData.list" :key="index" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.zt" placeholder="状态" clearable @change='bindTable()' class="filter-item" filterable>
                  <el-option v-for="(item, index) in xjydztData.list" :key="index" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="姓名/学号" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 按钮区域 -->
            <div class="button-box ">
              <el-button class="w200" type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column type="selection" align="center" width="55" />
              <el-table-column prop="xh" label="学号" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              </el-table-column>
              <el-table-column prop="xm" label="姓名" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="openDetailXueSheng=true;row={xsid:scope.row.xsid, xm:scope.row.xm}">{{scope.row.xm}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ydlb" label="异动类型" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in xjydlxData.list" :key="index">
                    <span v-if="scope.row.ydlb == item.value">{{item.label}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="ydrq" label="异动日期" align="center" show-overflow-tooltip />
              <!-- <el-table-column prop="ydyybt" label="异动原因" align="center" show-overflow-tooltip /> -->
              <el-table-column prop="ybjmc" label="原班级" align="center" show-overflow-tooltip />
              <el-table-column prop="xbjmc" label="现班级" align="center" show-overflow-tooltip />
              <el-table-column prop="zt" label="状态" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in xjydztData.list" :key="index">
                    <span v-if="scope.row.zt == item.value">{{item.label}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center" width="250">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" v-if="scope.row.zt == 0 || scope.row.zt == 10" @click="dataGrid.multipleSelection=[scope.row.id];submitClick()">
                    提交
                  </el-button>
                  <el-button link type="primary" v-if="scope.row.zt == 0" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" v-if="scope.row.zt == 0" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <detailxuesheng v-if="openDetailXueSheng" v-model:openDetail="openDetailXueSheng" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  homeCloseWindow,
  loadSelect,
  submitDataGridAction
} from '@/api/common.js'
import { getXjydlx, getXjydxt } from '@/utils/meiju.js'
import pagination from '@/components/pagination.vue'
import add from '@/pages/jiaowu/xuejiguanli/xuejiyidong/add.vue'
import edit from '@/pages/jiaowu/xuejiguanli/xuejiyidong/edit.vue'
import detail from '@/pages/jiaowu/xuejiguanli/xuejiyidong/detail.vue'
import detailxuesheng from '@/components/xuesheng/detail'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])
const xjydlxData = ref()
const xjydztData = ref()
// 弹窗
const row = ref()
const openList = ref(false)
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openDetailXueSheng = ref(false)

const zyList = ref()
const njList = ref()
const bjList = ref()
const initRXPYFA = async () => {
  // 专业名称
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyList,
    order: 'zydm',
    sort: 'asc'
  })
  // 专业名称
  loadSelect({
    url: '/api/v2/pdp/nianji/list',
    data: njList,
    order: 'njmc',
    sort: 'asc'
  })
  // 专业名称
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: bjList,
    order: 'xzbmc',
    sort: 'asc'
  })
}
initRXPYFA()
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/xueshengxuejiyidongjilu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 提交
const submitClick = () => {
  submitDataGridAction({
    url: '/api/v2/jiaowu/xueshengxuejiyidongjilu/submit',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要提交吗?',
    method: 'post',
    callback: function () {
      bindTable()
    }
  })
}
// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/jiaowu/xueshengxuejiyidongjilu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
watch(
  () => props.open,
  () => {
    if (props.open === 'xuejiyidong') {
      openList.value = true
      xjydlxData.value = getXjydlx()
      xjydztData.value = getXjydxt()
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
